<script>
export default {
  name: 'FornecedorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
    internalColor: {
      type: String,
      default: '#FFF',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="11" height="11" :fill="color" />
    <path
      d="M18.5408 4.17014L13.0408 2.11014C12.4708 1.90014 11.5408 1.90014 10.9708 2.11014L5.47078 4.17014C4.41078 4.57014 3.55078 5.81014 3.55078 6.94014V15.0401C3.55078 15.8501 4.08078 16.9201 4.73078 17.4001L10.2308 21.5101C11.2008 22.2401 12.7908 22.2401 13.7608 21.5101L19.2608 17.4001C19.9108 16.9101 20.4408 15.8501 20.4408 15.0401V6.94014C20.4508 5.81014 19.5908 4.57014 18.5408 4.17014ZM12.0008 16.2501C9.38078 16.2501 7.25078 14.1201 7.25078 11.5001C7.25078 8.88014 9.38078 6.75014 12.0008 6.75014C14.6208 6.75014 16.7508 8.88014 16.7508 11.5001C16.7508 14.1201 14.6208 16.2501 12.0008 16.2501Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8901 14.35C15.8901 14.6536 15.6406 14.9 15.3345 14.9H8.66786C8.36175 14.9 8.1123 14.6536 8.1123 14.35V8.3C8.1123 7.9964 8.36175 7.75 8.66786 7.75H9.22342C9.22342 9.26635 10.4695 10.5 12.0012 10.5C13.5329 10.5 14.779 9.26635 14.779 7.75H15.3345C15.6406 7.75 15.8901 7.9964 15.8901 8.3V14.35ZM11.4461 6.1946V7.2C11.4461 7.50415 11.695 7.75 12.0016 7.75C12.3083 7.75 12.5572 7.50415 12.5572 7.2V6.1946C13.07 6.3739 13.4744 6.79685 13.6166 7.34905C13.6516 7.4706 13.6683 7.60205 13.6683 7.75C13.6683 8.6597 12.9205 9.4 12.0016 9.4C11.0827 9.4 10.335 8.6597 10.335 7.75C10.335 7.6059 10.3522 7.47775 10.3855 7.3584C10.3872 7.3518 10.3877 7.34575 10.3894 7.33915L10.3916 7.3309C10.5316 6.7908 10.935 6.3728 11.4461 6.1946ZM15.3333 6.65H14.5433C14.1106 5.66055 13.1206 5 12 5C10.8761 5 9.88389 5.66495 9.45556 6.65H8.66667C7.74778 6.65 7 7.3903 7 8.3V14.35C7 15.2597 7.74778 16 8.66667 16H15.3333C16.2522 16 17 15.2597 17 14.35V8.3C17 7.3903 16.2522 6.65 15.3333 6.65Z"
      :fill="internalColor"
    />
  </svg>
</template>
